module.exports = __webpack_public_path__ + "static/media/nadirlogo.fe51feb6.png";